import { useContext } from "react";
import { LayoutContext } from "../contexts/LayoutContext.js";

const useLayout = () => useContext(LayoutContext);

export default useLayout;
